import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = {
  key: 1,
  style: {"height":"8px"}
}
const _hoisted_3 = {
  key: 2,
  class: "title"
}
const _hoisted_4 = {
  key: 4,
  class: "content"
}
const _hoisted_5 = {
  key: 5,
  class: "product-button"
}
const _hoisted_6 = {
  key: 1,
  class: "container"
}
const _hoisted_7 = { class: "no-data" }
const _hoisted_8 = {
  key: 2,
  class: "no-data"
}

import AccordionCardInfoDisplay from './AccordionCardInfoDisplay.vue'
import DividerHorizontal from '@/design-system/atoms/DividerHorizontal.vue'
import TooltipStandardV2 from '@/design-system/atoms/TooltipStandardV2.vue'
import IconInfoCircle from '@/design-system/assets/icons/IconInfoCircle.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSelectionStore } from '@/pinia/selection'
import { useI18n } from 'vue-i18n'
import { CoreEntityDto } from '@/interfaces/core.interface'
import { InfoData } from '@/utils/entityInformation'
import BadgeSquare from '@/design-system/atoms/BadgeSquare.vue'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoDisplayInformationCard',
  props: {
    showForEntityTypes: {},
    currentEntity: {},
    infoData: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const { t } = useI18n()
const store = useStore()
const selectionStore = useSelectionStore()
const { clickedEntityType } = storeToRefs(selectionStore)
const isExpanded = ref(false)

const infoTitle = computed(() => {
  switch (selectionStore.clickedEntityType) {
    case 'COMPLEX':
      return t('general__title__complex-information')
    case 'REAL_ESTATE':
      return t('general__title__realestate-information')
    case 'CONSTRUCTION':
      return t('general__title__construction-information')
    case 'LEVEL':
      return t('general__title__level-information')
    case 'SPACE':
      return t('general__title__space-information')
    case 'POI':
      return t('general__title__poi-information')
    case 'LINE':
      return t('general__title__line-information')
    case 'ZONE':
      return t('general__title__zone-information')
    default:
      return ''
  }
})
function handleClick() {
  isExpanded.value = !isExpanded.value
}
function openProductDetails() {
  store.commit('SET_STATUS_ON_SHOW_OVERLAY_MODAL', { toggleModal: true })
  store.commit('SET_CURRENT_OVERLAY_MODAL', { modalName: 'product' })
}
const allItemsMissingContent = computed(() => {
  return props.infoData.every((item) => !item.content && !item.poiProduct)
})

return (_ctx: any,_cache: any) => {
  return (_ctx.showForEntityTypes.includes(_unref(clickedEntityType)))
    ? (_openBlock(), _createBlock(AccordionCardInfoDisplay, {
        key: 0,
        heading: infoTitle.value,
        isExpanded: isExpanded.value,
        onOnClicked: handleClick
      }, {
        content: _withCtx(() => [
          (!_ctx.isLoading && _ctx.infoData?.length && !allItemsMissingContent.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoData, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "item"
                  }, [
                    (item.content && item.hasDivider)
                      ? (_openBlock(), _createBlock(DividerHorizontal, {
                          key: 0,
                          style: {"margin":"8px 0"}
                        }))
                      : _createCommentVNode("", true),
                    (item.poiProduct)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                      : _createCommentVNode("", true),
                    (item.content)
                      ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
                          _createTextVNode(_toDisplayString(item.title) + " ", 1),
                          (item.info)
                            ? (_openBlock(), _createBlock(TooltipStandardV2, {
                                key: 0,
                                class: "title__info",
                                text: item.info,
                                arrowPosition: 'bottom-center',
                                "vertical-offset": 2
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(IconInfoCircle, { class: "title__info" })
                                ]),
                                _: 2
                              }, 1032, ["text"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (item.isBadge && item.content)
                      ? (_openBlock(), _createBlock(BadgeSquare, {
                          key: 3,
                          style: {"margin-top":"4px"},
                          badgeText: item.content,
                          size: "small"
                        }, null, 8, ["badgeText"]))
                      : (item.content)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_4, _toDisplayString(item.content), 1))
                        : _createCommentVNode("", true),
                    (item.poiProduct)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(ButtonOutline, {
                            iconLeft: require('@/design-system/assets/icons/Icon-Arrow-up-right.svg'),
                            buttonText: _unref(t)('general__text__product-details'),
                            size: "small",
                            style: {"margin":"16px 0 0 0","width":"100%"},
                            onOnClicked: _cache[0] || (_cache[0] = () => openProductDetails())
                          }, null, 8, ["iconLeft", "buttonText"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : (!_ctx.isLoading && (allItemsMissingContent.value || !_ctx.infoData?.length))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('general__data__no-data-published')), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(PulseLoader, {
                    loading: true,
                    color: "#3F46D6"
                  })
                ]))
        ]),
        _: 1
      }, 8, ["heading", "isExpanded"]))
    : _createCommentVNode("", true)
}
}

})